import { Card } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";
import { Link } from "react-router-dom";

interface FeatureCardProps {
  to: string;
  icon: LucideIcon;
  title: string;
  description: string;
  image: string;
  delay?: string;
  featured?: boolean;
}

export const FeatureCard = ({
  to,
  icon: Icon,
  title,
  description,
  image,
  delay = "0s",
  featured = false,
}: FeatureCardProps) => {
  return (
    <Link to={to} className="block">
      <Card 
        className={`relative overflow-hidden border-2 hover:border-primary/50 transition-all duration-300 hover:shadow-lifted group ${
          featured 
            ? "h-[400px] md:h-[450px]" 
            : "h-[350px] md:h-[400px]"
        }`}
        style={{ animationDelay: delay }}
      >
        {/* Background Image with Overlay */}
        <div 
          className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.5)), url(${image})`
          }}
        />
        
        {/* Content */}
        <div className="relative z-10 h-full flex flex-col justify-end p-6 md:p-8">
          <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mb-4 group-hover:bg-white/30 transition-colors">
            <Icon className="h-6 w-6 md:h-7 md:w-7 text-white" />
          </div>
          
          <h3 className={`font-bold mb-2 md:mb-3 text-white ${
            featured ? "text-2xl md:text-3xl" : "text-xl md:text-2xl"
          }`}>
            {title}
          </h3>
          
          <p className="text-white/90 text-sm md:text-base leading-relaxed">
            {description}
          </p>
        </div>
      </Card>
    </Link>
  );
};
